import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import { collectionUrl } from '@/constants/urls';
import actions from '../constants';

export function* closeTab({ destroy, code }) {
  if (destroy) {
    yield call(listener.closeTab, [collectionUrl({ code })]);
  }
}
export default function* collectionSharingLayout() {
  yield takeEvery(actions.SHARE_COLLECTION_SUCCESS, closeTab);
}
